export const escapeText = (text: string): string => text.replace(/([^\w])/g, '\\$1')
